import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-agcharts',
	templateUrl:'./AgChartsPluginPage.html',
	styles: [],
	styleUrls:['./AgChartsPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgChartsPluginPage
{
	mdContent_49 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>agcharts</artifactId>
</dependency>
\`\`\``;
	mdContent_50 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:agcharts:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_51 = `\`\`\`json
"ag-charts-angular": "^13.1.0"
"ag-charts-community": "^13.1.0"
\`\`\``;
	mdContent_52 = `\`\`\`java
@NgComponent
public class SalesChart implements INgComponent<SalesChart> {
    public AgChartOptions<SalesChart> getOptions() {
        return new AgChartOptions<>(this)
            .setSeries(List.of(
                new AgLineSeriesOptions<>()
                    .setXKey("month")
                    .setYKey("sales")
                    .setYName("Sales")
            ))
            .setAxes(List.of(
                new AgCategoryAxisOptions<>()
                    .setPosition(AgCartesianAxisPosition.BOTTOM),
                new AgNumberAxisOptions<>()
                    .setPosition(AgCartesianAxisPosition.LEFT)
            ));
    }
}
\`\`\``;
	mdContent_53 = `\`\`\`java
var chart = new AgPieChart<>();
chart.getOptions()
    .setSeries(List.of(
        new AgPieSeriesOptions<>()
            .setAngleKey("value")
            .setLegendItemKey("label")
    ));
\`\`\``;
	mdContent_54 = `\`\`\`java
@NgComponent
public class SalesChart implements INgComponent<SalesChart> {
    public AgChartOptions<SalesChart> getOptions() {
        return new AgChartOptions<>(this)
            .setSeries(List.of(
                new AgLineSeriesOptions<>()
                    .setXKey("month")
                    .setYKey("sales")
                    .setYName("Sales")
            ))
            .setAxes(List.of(
                new AgCategoryAxisOptions<>()
                    .setPosition(AgCartesianAxisPosition.BOTTOM),
                new AgNumberAxisOptions<>()
                    .setPosition(AgCartesianAxisPosition.LEFT)
            ));
    }
}
\`\`\``;
}
